<div class="faq-page-container">
  <h1 #editable>Frequently asked questions</h1>
  <main>
    <thema-core-editable-expansion #editableComponent>
    </thema-core-editable-expansion>
  </main>
</div>
